import { Component, OnInit, ViewChild, ChangeDetectorRef, HostListener, SimpleChanges } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { Unidades } from '../../unidades';
import { UnidadService } from '../../unidad.service';


@Component({
  selector: 'app-unidad',
  templateUrl: './unidad.component.html',
  styleUrls: ['./unidad.component.scss']
})
export class UnidadComponent implements  OnInit {
  unidades: Unidades[] = [];
  unidadesActualizar: Unidades;
  listaUnidadesActulizar: Unidades[] = [];
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: Unidades[] = [];
  previous: any = [];
  isLoadingResults = true;

  constructor(private alertService: AlertService,private api: UnidadService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  mensaje(unid: Unidades) {



        this.editForm.controls.descripcion.setValue(unid.descripcion);
        this.editForm.controls.id.setValue(unid.id);
        this.editForm.controls.factor.setValue(unid.factor);
        this.editForm.controls.tipoUnidad.setValue(unid.tipoUnidad);
    this.mdbModal.show();

  }


listar(){

  this.api.getUnidades(localStorage.getItem('id'))
  .subscribe((
    data: Unidades[]) => {
    this.unidades = data;
    console.log(this.unidades);
    this.mdbTable.setDataSource(this.unidades);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {

    this.listar();

    this.editForm = this.formBuilder.group({
      descripcion: ['', Validators.required],
      factor: [0, Validators.required],
      id: [0, Validators.required],
      tipoUnidad: ['', Validators.required]
     
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminar(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..")
        this.listar();

      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }

  agregar() {
    this.editForm = this.formBuilder.group({
      id: [0],
      descripcion: ['', Validators.required],
      factor: [0, Validators.required],
      tipoUnidad: ['', Validators.required]
    });

    this.mdbModal.show();
    this.listar();
  }


  actulizar() {
    this.unidadesActualizar = new Unidades();
    this.unidadesActualizar.id=this.editForm.controls.id.value;
    this.unidadesActualizar.descripcion=this.editForm.controls.descripcion.value;
    this.unidadesActualizar.factor=this.editForm.controls.factor.value;
    this.unidadesActualizar.tipoUnidad=this.editForm.controls.tipoUnidad.value;
    this.unidadesActualizar.idEmisor = Number(localStorage.getItem('id'));
    this.listaUnidadesActulizar[0] = this.unidadesActualizar;

    this.api.setActulizar(this.listaUnidadesActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..")
        this.mdbModal.hide();
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  


  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.unidades = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.unidades = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
